import {useSyncExternalStore} from "react";

import {RECENT_FILTERS_STORAGE_KEY} from "../../../search/utils/recent_filters_storage";
import {subscribeToStorageKeys} from "../../../search/utils/storage_change_event";
import {PRICES_RECENT_SEARCHES_STORAGE_KEY} from "../constants/prices_search";
import type {IPricesRecentSearch, IPricesRecentStore} from "../types/IPricesSearchModel";
import {createLocalStorageListStore} from "../utils/prices_search/local_storage_list_store";
import {mapMainRecentToPrices} from "../utils/prices_search/map_main_recent_to_prices";
import {
    addPricesRecentSearch,
    clearPricesRecentSearches,
    mergePricesRecentSearches,
    pricesRecentSearchesStore,
    removePricesRecentSearch
} from "../utils/prices_search/prices_recent_searches_storage";

const EMPTY_RECENT: readonly IPricesRecentSearch[] = [];

// Read-only view of the main search store; the legacy single-object format is wrapped like `getRecentFilters` does.
const mainRecentSearchesStore = createLocalStorageListStore<readonly IPricesRecentSearch[]>({
    key: RECENT_FILTERS_STORAGE_KEY,
    parse: (value) => mapMainRecentToPrices(Array.isArray(value) ? value : [value]),
    empty: EMPTY_RECENT
});

let snapshot: {store: IPricesRecentStore; main: readonly IPricesRecentSearch[]; merged: readonly IPricesRecentSearch[]} | null = null;

// Both stores cache their parsed value by the raw string, so the merged list keeps its reference until one changes.
const getSnapshot = (): readonly IPricesRecentSearch[] => {
    const store = pricesRecentSearchesStore.read();
    const main = mainRecentSearchesStore.read();

    if (!snapshot || snapshot.store !== store || snapshot.main !== main) {
        snapshot = {store, main, merged: mergePricesRecentSearches(store, main)};
    }

    return snapshot.merged;
};

// Nothing is stored on the server; the client list appears after hydration, so the markup always matches.
const getServerSnapshot = (): readonly IPricesRecentSearch[] => EMPTY_RECENT;

const subscribe = (listener: () => void) => subscribeToStorageKeys([PRICES_RECENT_SEARCHES_STORAGE_KEY, RECENT_FILTERS_STORAGE_KEY], listener);

export interface IUsePricesRecentSearchesResult {
    /** Prices and main-search entries, newest first, at most PRICES_SEARCH_RECENT_SHOWN; [] on the server and before hydration. */
    items: readonly IPricesRecentSearch[];
    add: typeof addPricesRecentSearch;
    /** "×" on a row: removes the own entry and hides the main-search entries saved until now (a newer one shows again). */
    remove: typeof removePricesRecentSearch;
    /** "Wyczyść". */
    clear: typeof clearPricesRecentSearches;
}

/** Recent searches of the prices search, live across tabs and same-tab writes. */
export const usePricesRecentSearches = (): IUsePricesRecentSearchesResult => {
    const items = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

    return {items, add: addPricesRecentSearch, remove: removePricesRecentSearch, clear: clearPricesRecentSearches};
};
import {useSyncExternalStore} from "react";

import {RECENT_FILTERS_STORAGE_KEY} from "../../../search/utils/recent_filters_storage";
import {subscribeToStorageKeys} from "../../../search/utils/storage_change_event";
import {PRICES_RECENT_SEARCHES_STORAGE_KEY} from "../constants/prices_search";
import type {IPricesRecentSearch, IPricesRecentStore} from "../types/IPricesSearchModel";
import {createLocalStorageListStore} from "../utils/prices_search/local_storage_list_store";
import {mapMainRecentToPrices} from "../utils/prices_search/map_main_recent_to_prices";
import {
    addPricesRecentSearch,
    clearPricesRecentSearches,
    mergePricesRecentSearches,
    pricesRecentSearchesStore,
    removePricesRecentSearch
} from "../utils/prices_search/prices_recent_searches_storage";

const EMPTY_RECENT: readonly IPricesRecentSearch[] = [];

// Read-only view of the main search store; the legacy single-object format is wrapped like `getRecentFilters` does.
const mainRecentSearchesStore = createLocalStorageListStore<readonly IPricesRecentSearch[]>({
    key: RECENT_FILTERS_STORAGE_KEY,
    parse: (value) => mapMainRecentToPrices(Array.isArray(value) ? value : [value]),
    empty: EMPTY_RECENT
});

let snapshot: {store: IPricesRecentStore; main: readonly IPricesRecentSearch[]; merged: readonly IPricesRecentSearch[]} | null = null;

// Both stores cache their parsed value by the raw string, so the merged list keeps its reference until one changes.
const getSnapshot = (): readonly IPricesRecentSearch[] => {
    const store = pricesRecentSearchesStore.read();
    const main = mainRecentSearchesStore.read();

    if (!snapshot || snapshot.store !== store || snapshot.main !== main) {
        snapshot = {store, main, merged: mergePricesRecentSearches(store, main)};
    }

    return snapshot.merged;
};

// Nothing is stored on the server; the client list appears after hydration, so the markup always matches.
const getServerSnapshot = (): readonly IPricesRecentSearch[] => EMPTY_RECENT;

const subscribe = (listener: () => void) => subscribeToStorageKeys([PRICES_RECENT_SEARCHES_STORAGE_KEY, RECENT_FILTERS_STORAGE_KEY], listener);

export interface IUsePricesRecentSearchesResult {
    /** Prices and main-search entries, newest first, at most PRICES_SEARCH_RECENT_SHOWN; [] on the server and before hydration. */
    items: readonly IPricesRecentSearch[];
    add: typeof addPricesRecentSearch;
    /** "×" on a row: removes the own entry and hides the main-search entries saved until now (a newer one shows again). */
    remove: typeof removePricesRecentSearch;
    /** "Wyczyść". */
    clear: typeof clearPricesRecentSearches;
}

/** Recent searches of the prices search, live across tabs and same-tab writes. */
export const usePricesRecentSearches = (): IUsePricesRecentSearchesResult => {
    const items = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

    return {items, add: addPricesRecentSearch, remove: removePricesRecentSearch, clear: clearPricesRecentSearches};
};
